import { stringify } from 'qs';
import { getToken } from '../auth.js';
import { axiosInstance, buildHeaders } from '../axios-instance.js';
export function getAuthorizationHeader() {
    const token = getToken();
    const headers = token
        ? { Authorization: `JWT ${token}` }
        : undefined;
    return headers;
}
export async function sitFetch({ url, method, body, headers: additionalHeaders, pathParams, queryParams, signal, requestConfig, }) {
    const token = getToken();
    const headers = buildHeaders(additionalHeaders, token);
    // errors would be `AxiosError<_TError>`
    const data = body
        ? body instanceof FormData
            ? body
            : JSON.stringify(body)
        : undefined;
    const response = await axiosInstance.request({
        method: method.toUpperCase(),
        signal,
        url: resolveUrl(url, queryParams, pathParams),
        data,
        headers,
        ...requestConfig,
    });
    return response.data;
}
function pruneUndefinedValues(obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== undefined)
            acc[key] = value;
        return acc;
    }, {});
}
const resolveUrl = (url, queryParams = {}, pathParams = {}) => {
    const safeQueryParams = pruneUndefinedValues(queryParams);
    let query = stringify(safeQueryParams);
    if (query)
        query = `?${query}`;
    return url.replace(/{\w*}/g, (key) => pathParams[key.slice(1, -1)]) + query;
};
//# sourceMappingURL=sitFetcher.js.map